// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3LlRe","Open":"SideDrawer_Open__1YWPT","Close":"SideDrawer_Close__p3ell","Logo":"SideDrawer_Logo__3acsS"};